import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { ListenNodeView } from '../views/ListenNode';
import { OFFLINE_MODE } from '@/config/offline';

export const listenDefinition: NodeDefinition<'listen'> = {
  label: 'Listen',
  showInPalette: !OFFLINE_MODE,
  paletteColor: 'bg-lime-100 border-lime-500 text-lime-700',
  miniMapColor: '#84cc16',
  defaultData: { label: 'Listen' },
  view: ListenNodeView,
  run: async (_node, ctx, log) => {
    if (OFFLINE_MODE) throw new Error('Listen はオフラインでは使用できません（音声認識未対応）');
    if (!ctx.listener) {
      log('[Listen] エラー: 聞き取りが利用できません');
      return;
    }

    const result = await ctx.listener.listen();
    switch (result.status) {
      case 'success':
        ctx.lastValue = result.value;
        log(`[Listen] "${result.value}" を聞き取りました`);
        return;
      case 'cancelled':
        log('[Listen] キャンセルしました');
        return;
      case 'timeout':
        log('[Listen] タイムアウトしました');
        return;
      case 'error':
        log(`[Listen] エラー: ${result.message}`);
        return;
    }
  },
  help: {
    title: [t('Listen（'), r('聞', 'き'), t('き'), r('取', 'と'), t('り）')],
    description: [
      t('マイクに'),
      r('向', 'む'),
      t('かって'),
      r('話', 'はな'),
      t('した'),
      r('声', 'こえ'),
      t('を'),
      r('聞', 'き'),
      t('き'),
      r('取', 'と'),
      t('って、「ことば」にします。'),
      r('聞', 'き'),
      t('き'),
      r('取', 'と'),
      t('った「ことば」は、つぎのカードに'),
      r('渡', 'わた'),
      t('されます。'),
    ],
  },
};
